import { useUser } from "../../contexts/useUserData";
import { useEffect, useState } from "react";
import { receiveHistQuestions } from "../../api";
import styles from "./historyStyles.module.css";
import SVGMessage from "../../assets/svgComponents/Message";
import { PopupHistQuestions } from "./PopupHistQuestions"; //

interface Props {
    menuOpen: Function;
}

// Exportar la función `pullHistQuestions` para que pueda ser reutilizada
export async function pullHistQuestions(
    scope: any,
    pushReceivedHistQuestions: Function,
    removeHistQuestions: Function,
    seccion: string | undefined,
    loginMethod: string | undefined
) {
    console.log("pullHistQuestions ejecutándose");
    if (!scope) {
        console.warn("Falta scope:", { scope });
        return;
    }
    try {
        const result = await receiveHistQuestions(scope, seccion!, loginMethod!); // Llamada a la API
        console.log("Tipo de result:", Array.isArray(result) ? "Array" : typeof result);
        console.log("Datos obtenidos de la API (historial):", result);

        if (!Array.isArray(result)) {
            console.error("Error: result no es un array:", result);
            return;
        }

        // Validar y filtrar elementos válidos
        const validElements = result.filter(
            (element) => element && typeof element === "object" && "question" in element
        );

        console.log("Elementos válidos para map:", validElements);

        removeHistQuestions(); // Limpia el historial anterior

        // Mapeo de preguntas
        const arrayHistQuestions = validElements.map((element) => element.question);

        console.log("Preguntas procesadas para el historial:", arrayHistQuestions);

        // Agregar timestamps para medir el tiempo de guardado en el historial
        console.time("Tiempo para guardar historial");
        pushReceivedHistQuestions(arrayHistQuestions); // Almacena las preguntas en el estado global
        console.timeEnd("Tiempo para guardar historial");
    } catch (err) {
        console.error("Error al obtener el historial:", err);
    }
}

export const HistoryComponent = (propsData: Props) => {
    const { user, historyQuestions, pushReceivedHistQuestions, removeHistQuestions, scope, seccion, loginMethod } = useUser(); // Datos del usuario y métodos relacionados
    const [loading, setLoading] = useState<boolean>(false); // Estado para manejo del loading

    useEffect(() => {
        const fetchHistQuestions = async () => {
            if (!user || !scope || !pushReceivedHistQuestions || !removeHistQuestions) {
                console.error("Datos faltantes en el contexto:", { user, scope, pushReceivedHistQuestions, removeHistQuestions });
                return;
            }
    
            setLoading(true);
            await pullHistQuestions(scope, pushReceivedHistQuestions, removeHistQuestions, seccion, loginMethod);
            setLoading(false);
        };
    
        fetchHistQuestions(); // Llama a la API al montar el componente
    }, []);

    useEffect(() => {
        const fetchHistQuestions = async () => {
            if (!user || !scope || !pushReceivedHistQuestions || !removeHistQuestions) {
                console.error("Datos faltantes en el contexto:", { user, scope, pushReceivedHistQuestions, removeHistQuestions });
                return;
            }
    
            setLoading(true);
            await pullHistQuestions(scope, pushReceivedHistQuestions, removeHistQuestions, seccion, loginMethod);
            setLoading(false);
        };
    
        fetchHistQuestions(); // Llama a la API al montar el componente
    }, [scope]);

    return (
        <div id="history" className={styles.historyContainer}>
            <div className={styles.historyQuestions}>
                {loading ? (
                    <p className={styles.defaultMessage}>Cargando historial...</p>
                ) : historyQuestions && historyQuestions.length > 0 ? (
                    historyQuestions.map((element, index) => (
                        <div className={styles.historyBlock} key={index}>
                            <PopupHistQuestions
                                key={index}
                                content={element} // El texto de la pregunta
                                menuOpen={propsData.menuOpen} // Función para manejar el menú si es necesario
                            />
                            <div className={styles.detailedQuestion}>
                                <span>{element}</span>
                            </div>
                        </div>
                    ))
                ) : (
                    <div>
                        <p className={styles.defaultMessage}>Actualmente no tienes preguntas guardadas en el historial.</p>
                    </div>
                )}
            </div>
        </div>
    );
};